module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BoldIt.4ae9ba06.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BoldIt.woff
// module id = 353
// module chunks = 3